import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  if (shortTestimonials.length === 0) return null;
  return <section className="py-20 px-4 bg-zinc-900 border-y border-zinc-800" data-id="element-277" data-mp="3srmpvkst3ey1">
      <div className="max-w-6xl mx-auto" data-id="element-278" data-mp="3nyk3pxqcz7rv">
        <div className="text-center mb-12" data-id="element-279" data-mp="3nxqumq3xg66k">
          <h2 className="flex items-center justify-center gap-3 text-2xl md:text-4xl font-black uppercase text-white" data-id="element-280" data-mp="5kt1b21n4bld">
            <Star size={28} className="text-amber-400 shrink-0" fill="currentColor" aria-hidden="true" data-id="element-281" data-mp="lpy7n580fg1" />
            What MMA coaches are saying
          </h2>
          <p className="text-lg text-zinc-300 max-w-2xl mx-auto mt-4" data-id="element-282" data-mp="akyoo60vnbxn">
            Real feedback from coaches using MMA Coach Ready to save planning time, structure
            sessions and develop athletes more consistently.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-283" data-mp="2cdwk89m1gima">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-zinc-950 border border-zinc-800 rounded-2xl p-8 flex flex-col h-full" data-id="element-284" data-mp="caw945qy0524" data-mpi={index}>
              <div className="flex gap-1 text-amber-400 mb-5" aria-label="5 out of 5 stars" data-id="element-285" data-mp="102a1uct0a2nm">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={18} fill="currentColor" aria-hidden="true" data-id="element-286" data-mp="1456nkcdueevs" data-mpi={starIndex} />)}
              </div>

              <blockquote className="text-zinc-300 italic text-base leading-relaxed flex-grow" data-id="element-287" data-mp="190vqmpp2mdwu">
                “{testimonial.text}”
              </blockquote>

              <div className="border-t border-zinc-800 mt-6 pt-6 flex items-center gap-4" data-id="element-288" data-mp="3ave85uihdv7q">
                <div className="w-12 h-12 rounded-full bg-zinc-800 text-amber-400 font-bold flex items-center justify-center shrink-0 border-2 border-amber-400/60" aria-hidden="true" data-id="element-289" data-mp="i0w6v08w0min">
                  {testimonial.initials}
                </div>
                <div data-id="element-290" data-mp="m0errw0pkxlh">
                  <p className="font-bold text-white" data-id="element-291" data-mp="lzwo4ebpvh3j">{testimonial.name}</p>
                  <p className="text-sm text-zinc-300" data-id="element-292" data-mp="10xp0wypvpre1">{testimonial.role}</p>
                  <p className="text-xs text-zinc-500 flex items-center gap-1 mt-0.5" data-id="element-293" data-mp="w05n1zx3fgmm">
                    <MapPin size={12} aria-hidden="true" data-id="element-294" data-mp="19r0wbdbi7zqq" />
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}